import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import ReactAudioPlayer from 'react-audio-player';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogs({ temporal, openpop, temporalTitle, handleClickOpen, handleClose }) {
  const [subT] = React.useState("")



  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openpop}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}
        style={{color: temporalTitle === 'ANSWERED' ? 'green' : 'rgba(214, 44, 44, 0.7)'}}>
          {temporalTitle} <p style={{ fontSize: 14 }}>{subT}</p>
        </BootstrapDialogTitle>
        <DialogContent dividers 
            style={{backgroundColor: 'rgba(214, 44, 44, 0.7)'}}>

          <ReactAudioPlayer
            src={temporal}
            autoPlay={false}
            controls
          />

        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}
